export const navTabs = [
  { label: "Home", to: "/" },
  { label: "Cart", to: "/cart" },
];
